import React from 'react'
import CycleSummaryPanel from '../../../../components/material/DeviceDashboard/CycleSummary/CycleSummaryPanel'
import { useSelector } from "react-redux";

const CycleSummaryContainer = () => {
    // @ts-ignore
    const { deviceCycles, deviceTimezone } = useSelector((store) => store.devicedashboard);
    // @ts-ignore
    const loading = useSelector((store) => store.devicedashboard.loading.cycleSummary);

    return (
        <CycleSummaryPanel deviceCycles={deviceCycles} deviceTimezone={deviceTimezone} loading={loading} />
    )
}

export default CycleSummaryContainer
